<template>
  <v-container fluid>
    <gg-card>
      <gg-card-header>
        Select Your App
      </gg-card-header>
      <gg-card-text class="overflow-visible">
        <v-item-group active-class="primary" v-model="selection" >
          <v-row class="my-3">
            <v-col v-for="(item) in items" :key="item.key" cols="12" md="4">
              <v-item v-slot="{ active, toggle }" :value="item">
                <v-card class="app-card d-flex align-center relative overflow-visible" height="248" @click="toggle">
                  <div v-show="item.key === 'extendify'" class="most-popular">Recommended</div>
                  <v-card-text class="d-flex flex-col items-center full-height justify-space-between py-4" :style="cardActiveStyle(active)">
                    <v-img :src="wizardIcon(item)"
                           max-height="60"
                           class="ma-auto"
                           contain
                    />
                    <h3>
                      {{ item.name }}
                    </h3>
                    <h5 v-show="!!item.subtitle">
                      {{ item.subtitle }}
                    </h5>
                    <p class="text-center">
                      {{ item.description }}
                    </p>
                    <gg-btn class="" tile :color="active ? 'white' : 'primary'" outlined>
                      {{ active ? 'Selected' : 'Select' }}
                    </gg-btn>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </gg-card-text>
    </gg-card>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { cardActiveStyle, wizardIcon } from '@/helpers/wizard'

export default {
  name: 'NewWebsite',
  computed: {
    ...mapGetters({
      items: 'wizard/applications',
      selected: 'wizard_model/application'
    }),
    selection: {
      get () {
        return this.selected
      },
      set (val) {
        const app = val || {} // prevent undefined
        this.setChoice(app)
        if (val !== undefined) {
          this.applyInitialModel()
        }
      }
    }
  },
  beforeDestroy () {
    // Clear selection before component will be destroyed
    this.selection = undefined
  },
  methods: {
    ...mapMutations({
      setChoice: 'wizard_model/SET_APPLICATION_CHOICE',
      setInitialModel: 'wizard_model/SET_INITIAL_MODEL'
    }),
    cardActiveStyle,
    applyInitialModel () {
      const selected = this.selection
      const data = this.items

      const selected_app = data.find(app => app.key === selected.key)

      if (selected_app.defaults !== undefined) {
        if (selected_app.defaults !== false) {
          this.setInitialModel(selected_app)
        }
      }
    },
    wizardIcon
  }
}
</script>

<style scoped lang="scss">
.most-popular {
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff6b6b;
  color: #fff;
  padding: 4px 16px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  border-radius: 4px !important;
}
.full-height {
  height: 100% !important;
}
</style>
